module.exports = __webpack_public_path__ + "img/interface_pri.1cd93871.png";